/*
 * File: ContributorDashboard.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 13, 2024 at 9:21 AM
 * Copyright © 2024 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 1, 2025 at 1:18 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Components
import { Card } from '../../../components';

// Constants
import { DetailPanelWidth, mobileBreakpoint } from '../../../styles/constants';


/**
 * Styles
 */

export const Wrapper = styled.div`
	display: flex;
	gap: 24px;
	padding: 40px 0px 60px;
	width: 100%;
	justify-content: center;
	align-items: start;
	flex-direction: column;

	@media only screen and (min-width: ${mobileBreakpoint}em) {
		flex-direction: row;
	}
`;

export const StoryCard = styled(Card)`
	padding: 24px 36px 14px;
	max-width: ${DetailPanelWidth}px;
	width: 100%;
	position: relative;
`;

export const OptionsPanel = styled.div`
	max-width: 400px;
`;

export const OptionsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 23px;
	margin: 30px 0px 0px;
`;

export const OptionRow = styled.div`
	display: flex;
	gap: 12px;
`;

export const OptionContent = styled.div``;
